// Core i18n types supporting all languages from project.inlang/settings.json
export type SupportedLocale =
  | "en"
  | "ko"
  | "de"
  | "pt"
  | "no"
  | "es"
  | "ru"
  | "zh"
  | "zh-CN"
  | "zh-TW"
  | "ms"
  | "fr"
  | "it"
  | "nl"
  | "he"
  | "ar"
  | "id";
export const supportedLocales: SupportedLocale[] = [
  "en",
  "ko",
  "de",
  "pt",
  "no",
  "es",
  "ru",
  "zh",
  "zh-CN",
  "zh-TW",
  "ms",
  "fr",
  "it",
  "nl",
  "he",
  "ar",
  "id",
];
export const defaultLocale: SupportedLocale = "en";
